import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['selector-review']);
const allowedFixturePaths = new Set(['/ai/functions/workflow-binding-fixture']);

export function isFunctionWorkflowBindingSelectorVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('functionWorkflowBindingFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const functionWorkflowBindingSelectorVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return isFunctionWorkflowBindingSelectorVisualFixtureUrl(window.location.href);
};
